/**
 * SwipaSend — brand send/share icon.
 *
 * Visual: two right-pointing chevrons (>>) derived from the sWipa logo
 * (two up-chevrons, rotated 90° clockwise).  Used in chat input, DM input,
 * and story "share" action instead of the generic paper-plane from lucide.
 */
import { SVGProps } from 'react';

export function SwipaSend({
  size = 24,
  strokeWidth = 2.5,
  ...rest
}: SVGProps<SVGSVGElement> & { size?: number; strokeWidth?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...rest}
    >
      <polyline points="4 6 10 12 4 18" />
      <polyline points="11 6 17 12 11 18" />
    </svg>
  );
}

export default SwipaSend;
